module.exports = __webpack_public_path__ + "img/ht333_introduce_tw.d257be09.png";